<qbe-bluebox>
  <div class="offer-table">
    <div class="offer-table--header nx-margin-bottom-s u-desktop">
      <p nxCopytext="small" class="offer-table--label">
        <b>
          {{ 'offer.offerProtection.header.scope' | translate }}
        </b>
      </p>
      <p nxCopytext="small" class="offer-table--label">
        <b>
          {{ ((isResignation$ | async) ? 'offer.offerProtection.header.amount-resignation' : 'offer.offerProtection.header.amount') | translate }}
        </b>
      </p>
    </div>
    <div *ngFor="let coverage of coverages; index as i" class="offer-table--coverage nx-margin-bottom-s">
      <div class="offer-table--row nx-margin-bottom-3xs">
        <div class="offer-table--description">
          <qbe-custom-icons
            [icon]="coverage.enabled ? qbeIcons.Check : qbeIcons.Close"
            class="offer-table--icon"
            [ngClass]="{ enabled: coverage.enabled }"
          ></qbe-custom-icons>
          <p nxCopytext="normal">{{ coverage.name }}</p>
        </div>
        <div class="offer-table--price">
          <p nxCopytext="normal">
            <ng-container *ngIf="!coverage.limit && coverage.enabled">
              {{ 'offer.offerProtection.turn-on' | translate }}
            </ng-container>
            <ng-container *ngIf="coverage.limit">
              {{ coverage.limit.amount | aztCurrency : coverage.limit.currency }}<br/>
              <span class="u-mobile">
                {{ ((isResignation$ | async) ? 'offer.offerProtection.header.amount-resignation' : 'offer.offerProtection.header.amount') | translate }}
              </span>
            </ng-container>
          </p>
        </div>
      </div>
      <div *ngIf="coverage.additionalInformations?.additionalInfoItemsMore && coverage.additionalInformations.additionalInfoItemsMore.length > 0" class="offer-details">
        <nx-accordion variant="extra-light">
          <nx-expansion-panel (opened)="trackingOpen(coverage.codeName)">
            <nx-expansion-panel-header>
              <nx-expansion-panel-title>{{ 'offer.offerProtection.more' | translate }}</nx-expansion-panel-title>
            </nx-expansion-panel-header>
            <p *ngIf="coverage.additionalInformations.additionalInfo" nxCopytext="normal" class="offer-details-description nx-margin-bottom-xs" [innerHTML]="coverage.additionalInformations.additionalInfo | markdown"></p>
            <ul nxList="small">
              <li *ngFor="let infoMore of coverage.additionalInformations.additionalInfoItemsMore" class="offer-details-description" [innerHTML]="infoMore | markdown"></li>
            </ul>
          </nx-expansion-panel>
        </nx-accordion>
      </div>
    </div>
  </div>
</qbe-bluebox>
